/**
 * Node modules
 */
import socketIO from 'socket.io-client';

/**
 * Configurations
 */
import { app } from '../config';

/**
 * Shared, refcounted socket pool. Multiple components asking for the same
 * namespace+room+token share ONE connection instead of each performing its
 * own websocket handshake (a Play page used to open 5+). release() disconnects
 * only when the last user is gone, after a short linger so remount thrash
 * does not reconnect.
 */
const pool = new Map();
const RELEASE_LINGER_IN_MILLISECONDS = 3000;

const buildKey = input => [input.namespace || '/', input.room || '', input.token || ''].join('#');

export const releaseSocket = (socket) => {
  const key = socket && socket.__poolKey;
  const entry = key && pool.get(key);
  if (!entry) {
    if (socket) {
      socket.disconnect();
    }
    return;
  }
  entry.refs -= 1;
  if (entry.refs <= 0) {
    entry.lingerTimer = setTimeout(() => {
      if (entry.refs <= 0) {
        pool.delete(key);
        entry.socket.disconnect();
      }
    }, RELEASE_LINGER_IN_MILLISECONDS);
  }
};

export default (input) => {
  const {
    namespace = '/',
    room,
    token,
  } = input;
  const key = buildKey(input);
  const existing = pool.get(key);
  if (existing) {
    existing.refs += 1;
    if (existing.lingerTimer) {
      clearTimeout(existing.lingerTimer);
      existing.lingerTimer = null;
    }
    return existing.socket;
  }
  const bearerToken = token ? `Bearer ${token}` : undefined;
  const auth = {};
  if (room) {
    auth.room = room;
  }
  if (bearerToken) {
    auth.bearerToken = bearerToken;
  }
  const socket = socketIO(`${app.SOCKET_API_PROTOCOL}://${app.SOCKET_API_HOST}:${app.SOCKET_API_PORT}`.concat(namespace), {
    allowUpgrades: false,
    auth,
    path: '/socket.io',
    secure: true,
    transports: ['websocket'],
  });
  socket.__poolKey = key;
  pool.set(key, { lingerTimer: null, refs: 1, socket });
  return socket;
};
